import { Input, InputWrapperProps, MultiSelect, MultiSelectProps } from "@mantine/core";
import { useFormHelperContext } from "../form";
import { useController } from "react-hook-form";
import { InputWrapper } from "../inputWrapper";
import { useEffect, useState } from "react";

interface data {
    label: string;
    value: string;
}
export interface FieldInputMultiDropdownProps extends MultiSelectProps {
    label: string;
    name: string;
    inputWrapper?: InputWrapperProps;
    data: data[] | undefined;
}


export const FieldInputMultiDropdown: React.FC<FieldInputMultiDropdownProps> = ({ label, name, placeholder, inputWrapper, data, readOnly, ...rest }) => {
    const { register, control, watch, formStore } = useFormHelperContext();
    const { field, fieldState: { error } ,} = useController({ name, control });
    const [selectable, setSelectable] = useState<string[]>([]);
    const [selectedValue, setSelectedValue] = useState<string[] | undefined>(undefined);

    useEffect(() => {
        const { unsubscribe } = watch((value) => {
            const currentValue = value[name];
            
            if (currentValue && data && data.length > 0) {
                // resolve value to get label from data
                const resolvedValue = currentValue.map((value : string) => {
                    const item = data?.find((item) => item.value === value);
                    return item?.label;
                });
                setSelectedValue(resolvedValue);
            }
        })
        return () => unsubscribe()
      }, [watch, data])

    useEffect(() => {
        if (data) {
            const parsedData = data.map((item) => item.label)
            // remove duplicate from parsedData
            const uniqueData = Array.from(new Set(parsedData));
            setSelectable(uniqueData);
        }
    }, [data]);

    if (!register) {
        throw new Error("Field.MultiDropdown must be used within a FormHelper component");
    }

    const resolveLabelToValue = (label: string[]) => {
        return label.map((label) => {
            const item = data?.find((item) => item.label === label);
            return item?.value;
        });
    }

    return (
        <InputWrapper label={label} {...inputWrapper} withAsterisk={rest.withAsterisk}>
            <div className="flex flex-col w-full">
                <MultiSelect
                    data={selectable}
                    searchable
                    data-testid={'field-multi-dropdown-' + name}
                    placeholder={placeholder}
                    readOnly={readOnly ?? formStore.readOnly}
                    {...field}
                    {...rest}
                    value={selectedValue}
                    onChange={(value) => {
                        setSelectedValue(value);
                        // resolve array to get value from data 
                        field.onChange(resolveLabelToValue(value));
                    }}
                />

                {error && (
                    <Input.Error>{error.message}</Input.Error>
                )}
            </div>
        </InputWrapper>

    );
};

